import { createUseStyles } from 'react-jss';

export const settingsStyles = createUseStyles({
  container: {

  },
});
